import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import icons from './../../icons.svg';

const SignedInHeader = ({
  setActiveNav,
  replenishPlan,
  t,
  activeNav,
  cabinet,
  planogramConfig,
}) => {
  const hidePage = cabinet.calibration === 'on';
  // scale2: the refill tab already shows the lane planogram (product + count), so a separate planogram tab
  // is redundant. Kept during calibration as it is the only tab shown then (scale2 never calibrates anyway).
  const hidePlanogramTab = cabinet.scaleGeneration === 'scale2' && !hidePage;

  return (
    <header className="navigation">
      {/** Refill page */}
      {!hidePage && (
        <div
          className={`navigation__block ${
            activeNav === 'refill' ? 'navigation__block--active' : ''
          }`}
          onClick={() => setActiveNav('refill')}
        >
          <svg>
            <use xlinkHref={`${icons}#icon-refill`} />
          </svg>
          <span className="title">{t('refill')}</span>
        </div>
      )}

      {/** refill planogram */}
      {!hidePlanogramTab && (
        <div
          className={`navigation__block ${
            activeNav === 'planogram' ? 'navigation__block--active' : ''
          }`}
          onClick={() => setActiveNav('planogram')}
        >
          <svg>
            <use
              xlinkHref={`${icons}#${
                hidePage ? 'icon-balance-scale' : 'icon-planogram'
              }`}
            />
          </svg>
          {planogramConfig &&
            planogramConfig.data &&
            'shelves' in planogramConfig.data &&
            'shelvesCount' in planogramConfig.data && (
              <span
                className={`notification-dot ${
                  cabinet.calibration === 'on'
                    ? 'notification-dot--animate'
                    : ''
                }`}
              ></span>
            )}
          <span className="title">{t('planogram')}</span>
        </div>
      )}

      {/** refill plan */}
      {!hidePage && (
        <div
          className={`navigation__block ${
            activeNav === 'refillPlan' ? 'navigation__block--active' : ''
          }`}
          onClick={() => setActiveNav('refillPlan')}
        >
          <svg>
            <use xlinkHref={`${icons}#icon-file-text`} />
          </svg>
          <span className="title">{t('refillPlan')}</span>
        </div>
      )}
      {/** users page*/}
      {!hidePage && (
        <div
          className={`navigation__block ${
            activeNav === 'user' ? 'navigation__block--active' : ''
          }`}
          onClick={() => setActiveNav('user')}
        >
          <svg>
            <use xlinkHref={`${icons}#icon-user`} />
          </svg>
          <span className="title">{t('user')}</span>
        </div>
      )}
    </header>
  );
};

const mapStateToProps = ({ replenishPlan }) => ({ replenishPlan });

export default connect(mapStateToProps)(translate('common')(SignedInHeader));
